module.exports = __webpack_public_path__ + "static/01-6c866ee91adf8b061eaa83d7d286f64a.jpg";